var earthRadius = 3958.75, meterConversion = 1609;
export var getLatLngDistance = function (latlng1, latlng2) {
    return getDistance(latlng1.lat, latlng1.lng, latlng2.lat, latlng2.lng);
};
export function isInPolygon(pol, point) {
    var c = false;
    var nvert = pol.length;
    var lat = point.lat;
    var lng = point.lng;
    for (var i = 0, j = nvert - 1; i < nvert; j = i++) {
        var vertex1 = pol[i];
        var vertex2 = pol[j];
        if ((vertex1.lng < lng && vertex2.lng >= lng) ||
            (vertex2.lng < lng && vertex1.lng >= lng)) {
            if (vertex1.lat +
                ((lng - vertex1.lng) / (vertex2.lng - vertex1.lng)) *
                    (vertex2.lat - vertex1.lat) <
                lat) {
                c = !c;
            }
        }
    }
    return c;
}
var getDistance = function (lat1, lng1, lat2, lng2) {
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) *
            Math.cos(toRad(lat2)) *
            Math.sin(dLng / 2) *
            Math.sin(dLng / 2);
    return (earthRadius *
        meterConversion *
        2 *
        Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
};
var toRad = function (n) {
    return (n * Math.PI) / 180;
};
//# sourceMappingURL=geoLogic.js.map